import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { StatusCardComponent } from '../status-card/status-card.component';
import { StatusListComponent } from './status-list.component';

@NgModule({
    declarations: [StatusListComponent, StatusCardComponent],
    imports: [CommonModule, MatProgressSpinnerModule, TranslateModule, MatIconModule, MatButtonModule, MatMenuModule],
    exports: [StatusListComponent],
})
export class StatusListModule {}
